const $ = require('./js/plugins/jquery.min');
global.$ = global.jQuery = $;
require('./js/src/modules');
require('./js/plugins/jquery.validate.min');

require('./js/plugins/jquery.inputmask.min.js');
global.io = require('./js/plugins/socket.io.min.js');
require('./js/src/preloader');
require('./js/src/ajax');
require('./js/src/burger');
require('./js/src/select');
require('./js/src/checkbox');
require('./js/src/validation');
require('./js/src/main');
require('./js/src/socket');
require('./js/src/notifications');
require('./js/src/popups');
require('./js/src/shares');
require('./js/src/footer_details');
require('./js/src/ajax_popups');
require('./js/src/subscribe_blog');
require('./js/src/captcha');

require('./css/basic.css');
require('./css/footer.css');
require('./css/header.css');
require('./css/style-bundle.css');
require('./css/main-page.css');
require('./css/blog.css');
require('./css/blog-details.css');
require('./css/listing.css');
require('./css/temp.css');

jQuery(function () {
  global.modules.init();
  $(window).on("popstate", function() {
    window.location = location.href
  });
})
